import { render, staticRenderFns } from "./exam.vue?vue&type=template&id=3082c942&scoped=true"
import script from "./exam.vue?vue&type=script&lang=js"
export * from "./exam.vue?vue&type=script&lang=js"
import style0 from "./exam.vue?vue&type=style&index=0&id=3082c942&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3082c942",
  null
  
)

export default component.exports